import { copyLink } from '../Utils/copy-link';

/**
 * In the PDP QR Code popover, we have a copy link button. Handle that here.
 */
document.addEventListener( 'DOMContentLoaded', () => {
	const shareImgWrapper = document.querySelector( '.js-qala-qr-codes-woo-product-share-img-container' );

	if ( shareImgWrapper ) {
		copyLink();
	}
} );
